import React, { useCallback, useEffect, useState } from "react";
import ListTable from "./components/ListTable";
import ToolBar from "../../../components/ToolBar";
import { Tabs } from "antd";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import { fetchListStarProvider } from "../../../store/StarProviderSlice";
import AddStarProviders from "./components/AddStarProviders";
import EditStarProviders from "./components/EditStarProviders";
import SearchStarProviders from "./components/SearchStarProviders";
import DeleteStarProviders from "./components/DeleteStarProviders";

const StarProviders: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [listHaveData, setListHaveData] = useState<boolean>(true);
  const [savePayload, setSavePayload] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [editModalData, seteditModalData] = useState<any>();

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const getList = useCallback(
    (data?: any) => {
      setTableLoading(true);
      const payload = {
        ...data,
        pageNumber: data?.pageNumber ?? paginationData?.pageNumber,
        pageSize: data?.pageSize ?? paginationData?.pageSize,
      };
      setSavePayload(payload);
      dispatch(fetchListStarProvider(payload))
        .then((res: any) => {
          setListHaveData(false);
          setListData(res?.indexedResults);
          setTotalData(res?.totalRecords);
          setTableLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0);
          setTableLoading(false);
        });
    },
    [dispatch, paginationData]
  );

  useEffect(() => {
    if (listHaveData) {
      getList();
    }
  }, [getList, listHaveData]);

  const handleEditModal = (record: any) => {
    setOpenEditModal(!openEditModal);
    seteditModalData(record);
  };

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  return (
    <>
      <ToolBar title={"Asterisk Providers"} />
      <Tabs
        defaultActiveKey="1"
        type="card"
        size="large"
        onChange={getList}
        items={[
          {
            key: "1",
            label: "Add Asterisk Providers",
            children: (
              <AddStarProviders getList={getList} totalData={totalData} />
            ),
          },
          {
            key: "2",
            label: "Search Asterisk Providers",
            children: (
              <SearchStarProviders
                getList={getList}
                setPaginationData={setPaginationData}
              />
            ),
          },
        ]}
      />
      <ListTable
        listData={listData}
        setListData={setListData}
        totalData={totalData}
        tableloading={tableloading}
        setTableLoading={setTableLoading}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        getList={getList}
        savePayload={savePayload}
        handleEditModal={handleEditModal}
        handleDeleteRequest={handleDeleteRequest}
      />
      <EditStarProviders
        editModalData={editModalData}
        openEditModal={openEditModal}
        handleEditModal={handleEditModal}
        getList={getList}
      />
      <DeleteStarProviders
        title={openDeleteData?.providers}
        close={handleDeleteRequest}
        open={openDeleteModal}
        deleteValues={openDeleteData}
        name={"Provider Code"}
        getList={getList}
      />
    </>
  );
};

export default StarProviders;
